import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Button, Input, UncontrolledTooltip } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { WQDATA, SAMPLINGPOINTS, PARAMETERS, WQSAMPLES, COMPANY } from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';

import PropTypes from 'prop-types';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const WQData = () => {

        const { ExportCSVButton } = CSVExport;

        toastr.options = TOAST_OPTIONS;

        const [modal, setmodal] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [dataList, setDataList] = useState([]);
        const [paramsList, setParamsList] = useState([]);
        const [sPointsList, setSPointsList] = useState([]);
        const [isloading, setIsloading] = useState(false);

        const fetchData = () => {
          axios.get(WQDATA, Config).then((r)=>{ setDataList(r.data);  }).catch((e)=>{  console.log(e); });
          axios.get(SAMPLINGPOINTS, Config).then((r)=>{ setSPointsList(r.data);  }).catch((e)=>{  console.log(e); });
          axios.get(PARAMETERS, Config).then((r)=>{ setParamsList(r.data);  }).catch((e)=>{  console.log(e); });
        }

        useEffect(() => {
          setIsloading(true)
          fetchData();
          setIsloading(false)
        },[]);

        const filterWQData = () => {
            const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
            const startDate = formatDate(dateRange[0]);
            const endDate = formatDate(dateRange[1]);  
            const param = document.getElementsByClassName('filterParam')[0].value
            const sPoint = document.getElementsByClassName('filterSP')[0].value
            
        }

        const { SearchBar } = Search;
        const columns = [
        
        {
          dataField: 'date',
          text: 'Date',
          sort: true
        }
        ,
        {
          dataField: 'sample',
          text: 'Sample',
          sort: true
        },
        {
          dataField: 'point',
          text: 'Sampling Point',
          sort: true
        },
        {
          dataField: 'param',
          text: 'Parameter',
          sort: true
        },
        {
          dataField: 'result',
          text: 'Result',
          sort: true
        },
        {
            dataField: 'unit',
            text: 'Unit',
            sort: true
        },
        {
            dataField: 'postedBy',
            text: 'Posted By',
            sort: true
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "Action",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'date',
          order: 'desc'
        }];
        function actionFormatter(cellContent, row){
          return(
            <>
              <Button
                type="button"
                color="info"
                className="btn-sm btn-rounded">
                Details
              </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
              active={isloading}
              spinner={<BounceLoader />}
              text='Please wait...'
              >
                <div className="page-content">
                    <MetaTags>
                    <title>Quality Data | {COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={COMPANY} breadcrumbItem="Water Quality Data" />

                        <Row>
                        <Col lg={12}>
                          <Card>
                            <CardBody>
                              <CardTitle className="h5 mb-4">Filter Data</CardTitle>
                              <Form className="row gy-2 gx-3 align-items-center">
                                <Row>
                                <Col lg={2}>
                                <div className="col-sm-auto">
                                    <Flatpickr
                                      className="form-control d-block filterDate"
                                      placeholder="dd M,yyyy"
                                      options={{
                                        mode: "range",
                                        dateFormat: "Y-m-d"
                                      }}
                                    />
                                </div>
                                </Col>
                                <Col lg={3}>
                                <div className="col-sm-auto">
                                  <label className="visually-hidden" htmlFor="autoSizingSelect">By Parameter</label>
                                  <select defaultValue="0" className="form-select filterParam"> 
                                    <option value=""> Select Parameter</option>
                                    <option value="">All</option>
                                    { paramsList && (paramsList.length > 0) && (
                                        (paramsList || []).map((p,k)=>(
                                            <option key={k} value={p.id}>{p.name}</option>
                                        ))
                                    )}
                                  </select>
                                </div>
                                </Col>
                                <Col lg={3}>
                                <div className="col-sm-auto">
                                  <label className="visually-hidden" htmlFor="autoSizingSelect">By Sampling Point</label>
                                  <select defaultValue="0" className="form-select filterSP">
                                    <option value=""> Select Sampling Point</option>
                                    <option value="">All</option>
                                    { sPointsList && (sPointsList.length > 0) && (
                                        (sPointsList || []).map((p,k)=>(
                                            <option key={k} value={p.id}>{p.name}</option>
                                        ))
                                    )}
                                  </select>
                                </div>
                                </Col>
                                <Col lg={2}>
                                <div className="col-sm-auto">
                                  <button type="button" onClick={filterWQData} className="btn btn-primary w-md">Filter</button>
                                </div>
                                </Col>
                                <Col lg={2}> <div className="text-sm-end">
                                  <Link
                                    className="btn btn-success"
                                    to="/Add-Quality-Data"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Submit Data
                                  </Link>
                                </div></Col>
                                </Row>
                              </Form>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>  
                      <Row>             
                        <Col lg="12">
                        <Card>
                            <CardBody>
                            <CardTitle className="mb-4">&nbsp;</CardTitle>

                            {dataList && (dataList.length > 0) && (
                                <>
                                
                                <ToolkitProvider
                                      keyField="id"
                                      data={ dataList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row className="mb-2">
                                              <Col sm="4">
                                                <div className="search-box me-2 mb-2 d-inline-block">
                                                  <div className="position-relative">
                                                    <SearchBar {...toolkitProps.searchProps} />
                                                    <i className="bx bx-search-alt search-icon" />
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col sm="8">
                                                <div className="text-sm-end">
                                                    <ExportCSVButton { ...toolkitProps.csvProps } className="btn btn-primary"> <i className="mdi mdi-plus me-1" /> Export CSV!!</ExportCSVButton>
                                                </div>  
                           
                                              </Col>
                                            </Row>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ dataList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>


                                </>
                            )}
                            {dataList && (dataList.length < 1) && (
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                    </div>
                                    <div>
                                    <h5>No Data Found</h5>
                                    <p className="text-muted">
                                            
                                    </p>
                                    </div>
                                </div>

                            )}
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }
    WQData.propTypes = {
        csvProps: PropTypes.any,
        baseProps: PropTypes.any
      };
export default WQData;